
window.cookieConsent = () => {
    return {
        open: true,
        displayPreferences: false,
        consent: {
            technical: true,
            analytic: false,
            marketing: false
        },

        init() {
            let cc = window.localStorage.getItem('cc');
            this.open = cc == null;
            if (cc) {
                this.consent = JSON.parse(window.localStorage.getItem('cc'));
                this.emit();
            }
        },

        storeConsent() {
            window.localStorage.setItem('cc', JSON.stringify(this.consent));
            this.emit();
            this.open = false;
        },

        consentAll() {
            this.consent = {
                technical: true,
                analytic: true,
                marketing: true
            };
            this.storeConsent();
        },

        consentRequired() {
            this.consent = {
                technical: true,
                analytic: false,
                marketing: false
            };
            this.storeConsent();
        },

        consentSelected() {
            this.storeConsent();
        },

        emit() {
            if (this.consent.analytic) {
                console.log('cc-analytic');
                window.dataLayer && window.dataLayer.push({ event: 'cc-analytic'});
            };
            if (this.consent.marketing) {
                console.log('cc-marketing');
                window.dataLayer && window.dataLayer.push({ event: 'cc-marketing'});
            };
        }
    }
}

module.exports = window.cookieConsent;
